module.exports = __webpack_public_path__ + "img/slider-4.5237d1fe.jpg";